import { useSelector } from 'react-redux';

// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';

import { useDetectPastesHistory } from '@edu-frontend/modules/src/features/pastesHistory';

import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';

export function useIsShowPastesAvailable(subject: SUBJECTS_SLUGS | true) {
    const showPastesFlag = useSelector(getFeatureFlags)?.showPastes;

    return !!showPastesFlag && (subject === true || subject === SUBJECTS_SLUGS.informatics);
}

export function useShouldShowPastes(subject: SUBJECTS_SLUGS | true) {
    const isAvailable = useIsShowPastesAvailable(subject);
    const isTurnedOn = useDetectPastesHistory().detectPaste;

    return isAvailable && isTurnedOn;
}
